import React, { useEffect, useState } from "react"
import clxs from "./guest-consent-form.module.css";
import Button from "../Button";
import GuestConsentContent from "./GuestConsentContent";
import { useLoginModal } from "../../hooks/use-login-modal";
import CHECK_GREEN from "../../assets/icons/green-checkmark.svg";
import { useQueryParamValue } from "../../hooks/use-query-param";
import { useSnackbar } from "../../hooks/use-snackbar";
import useUserService from "../../hooks/use-user-service";
import { DesktopConsentItem, formatConsentList, MobileConsentItem } from "./use-format-consent-data";
import useIsMobile from "../../hooks/use-is-mobile";
import useClx from "../../hooks/use-clx";
import fwclxs from "../../styles/full-width.module.css";

function GuestConsentForm() {
  const { service: userService } = useUserService(),
    enqueueSnackbar = useSnackbar(),
    showLoginFlowModal = useLoginModal(),
    { isMobile } = useIsMobile(),
    reserve_booking_slug = useQueryParamValue("string", "slug"),
    hcx = useClx(fwclxs.container, fwclxs.containerPadding, clxs.container),
    fcx = useClx(fwclxs.container, fwclxs.containerPadding, clxs.footer),
    [isChecked, setIsChecked] = useState(false),
    [reservationData, setReservationData] = useState<(MobileConsentItem | DesktopConsentItem)[]>([]),
    /**
     * API call to get reservation details for mobile view
     */
    getReservationDetails = async (slug: string, isMobileFlag: boolean) => {
      if (!slug) {
        return;
      }

      const { error, response } = await userService.concentFormCheck(slug);

      if (error) {
        enqueueSnackbar(error.message, "error");
        return;
      }

      if (response) {
        const finalData = formatConsentList(response.reservations, isMobileFlag)
        setReservationData(finalData);
      }

    },
    /**
     * Handle chckbox change event
     */
    handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      setIsChecked(e.target.checked);
    },
    /**
     * Handle login button click event
     */
    handleLoginClick = () => {
      showLoginFlowModal({});
    };

  useEffect(() => {
    if (isMobile) {
      getReservationDetails(reserve_booking_slug, isMobile)
    }
  }, [reserve_booking_slug, isMobile]);

  return (
    <div className={hcx}>
      <div className={clxs.card}>
        <div className={clxs.header}>
          <img
            src={CHECK_GREEN}
            alt="Points Success"
            className={clxs.checkGreen}
          />
          <span className={clxs.headerText}>Check-in for:</span>
        </div>

        <hr className={clxs.separator} />

        <div className={clxs.list}>
          {reservationData.map((item, index) => (
            <div
              key={index}
              className={clxs.row}
            >
              <div className={clxs.textBlock}>
                <div className={clxs.title}>{item.title}</div>
                <div className={clxs.subTitle}>{item.location}</div>
              </div>
              <div className={clxs.dateBlock}>
                <div className={clxs.range}>{(item as MobileConsentItem).range}</div>
                <div className={clxs.month}>{(item as MobileConsentItem).month}</div>
              </div>
            </div>
          ))}
        </div>

      </div>

      <div className={clxs.content}>
        <GuestConsentContent
          isChecked={isChecked}
          handleCheckboxChange={handleCheckboxChange}
        />
      </div>

      <div className={fcx}>
        <Button
          disabled={!isChecked || !reserve_booking_slug}
          className={(!isChecked || !reserve_booking_slug) ? clxs.disableBtn : clxs.confirmBtn}
          type="submit"
          onClick={handleLoginClick}
        >
          Proceed to Confirm
        </Button>
      </div>
    </div>
  );
}

export default GuestConsentForm
